export interface FantasyFixture {
  player_id: string;
  match_type: "FOOTBALL";
  market: "PLAYER_PERFORMANCE";
}

export default class FantasyPredictionRequestBody {
  public template_id: string = null;
  public group_id: string = null;
  public fixtures: FantasyFixture[] = [];
}
